<template>
  <div class="ringAnalysisTree">
    <el-radio-group
      v-model="typeFiltering"
      @change="changetypeFiltering"
      size="small"
    >
      <el-radio-button label="分项系统">系统</el-radio-button>
      <el-radio-button label="区域位置">区域</el-radio-button>
      <el-radio-button label="单位部门">部门</el-radio-button>
    </el-radio-group>
    <el-row>
      <el-radio-group
        v-model="activeType"
        size="mini"
        style="margin-top: 20px"
        @change="handleTimeChage"
      >
        <el-radio v-for="v in energyTypeList" :key="v.key" :label="v.key">{{
          v.name
        }}</el-radio>
      </el-radio-group>
    </el-row>
    <div class="timeBox">
      <el-select
        v-model="timeType"
        placeholder="请选择"
        style="width: 25%"
        size="small"
        @change="getDataValue"
      >
        <el-option
          v-for="v in defaultTimeList"
          :key="v.value"
          :label="v.label"
          :value="v.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        size="small"
        v-model="timeValue"
        :clearable="false"
        :type="
          timeType == 'YEAR' ? 'year' : timeType == 'MONTH' ? 'month' : 'date'
        "
        :key="
          timeType == 'YEAR' ? 'year' : timeType == 'MONTH' ? 'month' : 'date'
        "
        :value-format="
          timeType == 'YEAR'
            ? 'yyyy'
            : timeType == 'MONTH'
            ? 'yyyy-MM'
            : 'yyyy-MM-dd'
        "
      >
      </el-date-picker>
    </div>
    <div class="timeBox">
      <el-checkbox v-model="cascade" border size="mini" @change="changeCascade"
        >级联选择</el-checkbox
      >
    </div>
    <div style="width: 100%; height: 65%; margin: 10px 0 20px 0">
      <el-tree
        :data="dataList"
        :props="defaultProps"
        node-key="id"
        highlight-current
        accordion
        show-checkbox
        :check-strictly="!cascade"
        :default-expanded-keys="defaultKeys"
        ref="tree"
        style="
          overflow: auto;
          background: #f7f7f7;
          border: 1px solid #e7e7e7;
          border-radius: 6px;
          padding: 20px 0 30px;
          margin-top: 10px;
          height: 88%;
        "
      >
      </el-tree>
    </div>
    <div class="btnBox">
      <el-button type="primary" icon="el-icon-search" @click="onSubmit"
        >搜索</el-button
      >
      <el-button @click="resetting">重置</el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  data() {
    return {
      typeFiltering: "分项系统",
      defaultProps: {
        children: "children",
        label: "name",
      },
      cascade: false,
      dataList: [],
      treeAllData: {}, //全部树数据
      defaultKeys: [], //默认打开
      energyTypeList: [],
      activeType: "",
      timeType: "",
      timeValue: new Date(),
      defaultTimeList: [],
    };
  },
  methods: {
    getDataValue() {
      if (this.timeType == "YEAR") {
        this.timeValue = dateFtt("yyyy", new Date());
      } else if (this.timeType == "MONTH") {
        this.timeValue = dateFtt("yyyy-MM", new Date());
      } else if (this.timeType == "DAY") {
        this.timeValue = dateFtt("yyyy-MM-dd", new Date());
      } else {
        this.timeValue = null;
      }
    },
    handleTimeChage() {
      this.$store.commit("SET_LOADING", true);
      if (this.activeType == "power") {
        this.defaultTimeList = [
          { label: "日", value: "DAY" },
          { label: "月", value: "MONTH" },
          { label: "年", value: "YEAR" },
        ];
      } else {
        this.defaultTimeList = [
          { label: "月", value: "MONTH" },
          { label: "年", value: "YEAR" },
        ];
      }
      this.timeType = this.defaultTimeList[0].value;
      this.getDataValue();
      this.getAsseList();
    },
    onSubmit() {
      if (this.$refs.tree.getCheckedKeys().length == 0) {
        this.$message.error("请选择资产");
        return;
      } else if (this.$refs.tree.getCheckedKeys().length > 10) {
        this.$message.error("最多可选10条");
        return;
      }
      let data = {
        assetId: this.$refs.tree.getCheckedKeys(),
        activeType: this.activeType,
        type: this.timeType,
        date: this.timeValue,
        activeType: this.activeType,
      };
      this.$emit("getTreeActive", data);
    },
    resetting() {
      this.typeFiltering = "分项系统";
      this.changetypeFiltering("resetting");
    },
    changeCascade() {
      this.$refs.tree.setCheckedKeys([]);
    },
    changetypeFiltering(type) {
      this.dataList = this.treeAllData[this.typeFiltering]
        ? [this.treeAllData[this.typeFiltering]]
        : [];
      this.$refs.tree.setCheckedKeys([]);
      this.defaultKeys = [];
      if (type == "resetting" && this.dataList.length) {
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([this.dataList[0].id]);
          this.defaultKeys.push(this.dataList[0].id);
        });
      }
    },
    async getAsseList() {
      this.treeAllData = {};
      this.dataList = [];
      let obj = this.energyTypeList.find((v) => {
        return v.key === this.activeType;
      });
      let res = await api.lightSystemAssetsTreeMenu({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        projectName: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectName,
        option: "HasEUDevice",
        deviceType: obj.deviceTypes ?? "",
      });

      if (res && res.status == 200) {
        this.$store.commit("SET_LOADING", false);
        this.treeAllData = res.data.assets ?? {};
        this.dataList = this.treeAllData[this.typeFiltering]
          ? [this.treeAllData[this.typeFiltering]]
          : [];
        if (this.dataList.length) {
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys([this.dataList[0].id]);
            this.defaultKeys.push(this.dataList[0].id);
            let data = {
              assetId: this.$refs.tree.getCheckedKeys(),
              activeType: this.activeType,
              type: this.timeType,
              date: this.timeValue,
              activeType: this.activeType,
            };
            this.$emit("getTreeActive", data);
          });
        }
      }
    },
  },
  created() {
    this.energyTypeList = JSON.parse(
      window.sessionStorage.getItem("energyType")
    );
    this.activeType = this.energyTypeList[0]?.key ?? "power";
    this.handleTimeChage();
  },
};
</script>

<style lang="scss" scoped>
.ringAnalysisTree {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  overflow: auto;
  ::v-deep
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $themeColor !important;
    color: #fff;
  }
  .timeBox {
    margin: 10px 0;
    @include setFlexBetween;
  }
  .btnBox {
    @include setFlexCenter;
  }
}
</style>
